import { makeStyles } from '@material-ui/core/styles';
import { THEME } from 'GlobalStyles';

const color = `${THEME.palette.common.white} !important`;

export const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    zIndex: 500,
    borderRadius: 0
  },
  standardSuccess: {
    backgroundColor: theme.palette.success.main,
    color
  },
  standardError: {
    backgroundColor: theme.palette.error.main,
    color
  },
  message: {
    fontWeight: 400,
    fontSize: 16
  },
  icon: {
    color
  },
  standardInfo: {
    backgroundColor: theme.palette.info.fill,
    color: theme.palette.brandColors.FPWhite
  }
}));

export const useButtonStyle = makeStyles(theme => ({
  outlined: {
    ...theme.button,
    width: 'unset',
    color: THEME.palette.common.white,
    border: `1px solid ${color}`,
    margin: theme.spacing(0, 1),
    '&:hover': {
      backgroundColor: 'unset'
    }
  }
}));
